/**
 * Uplifted WHOLE from `apps/web/src/utils/keyboardKeysConstants.ts` (29 exports).
 *
 * WEB-ONLY, verified rather than assumed (hazard 32): `find apps/mobile/src -iname "*keyboard*"`
 * returns only `utils/useIsKeyboardOpen.tsx` and `reduxStore/slices/KeyBoardShortcuts.ts` —
 * neither is this module, and mobile has no keyboard-chord vocabulary at all. Hence a
 * single-variant folder with no `shared.ts`, which rule 4 allows exactly here.
 *
 * These are `KeyboardEvent`-derived chord STRINGS matched against what the web app's shortcut
 * layer produces. Pure data — no imports, nothing read at load time.
 *
 * ⚠️ Several names differ only by CASE of the final letter, and both spellings are live —
 * `CONTROL_SHIFT_v` / `CONTROL_SHIFT_V`, `CONTROL_SMALLK` / `CONTROL_CAPITALK`,
 * `CONTROL_SHIFT_P` / `CONTROL_SHIFT_SMALLP`. The browser reports a different `key` depending
 * on whether Shift is held, so the pairs are checked together. Do not dedupe them.
 *
 * ⚠️ `ID = 'id'` is not a key chord at all; it is transcribed verbatim because the app file
 * exports it from here and consumers import it from here.
 */
export const CONTROL_ENTER = "Control+Enter";
export const CONTROL_SPACE = "Control+Space";
export const ESCAPE = "Escape";
export const ESC = "Esc";
export const CONTROL_1 = "Control+1";
export const CONTROL_2 = "Control+2";
export const CONTROL_3 = "Control+3";
export const CONTROL_4 = "Control+4";
export const ENTER = "Enter";
export const SPACE = "Space";
export const F8 = "F8";
export const F10 = "F10";
export const ARROWDOWN = "ArrowDown";
export const ARROWUP = "ArrowUp";
export const CONTROL_SHIFT_P = "Control+Shift+P";
export const CONTROL_SHIFT_SMALLP = "Control+Shift+p";
export const CONTROL_SHIFT_SPACE = "Control+Shift+Space";
export const CONTROL_SHIFT_v = "Control+Shift+v";
export const CONTROL_SHIFT_V = "Control+Shift+V";
export const CONTROL_SMALLK = "Control+k";
export const CONTROL_CAPITALK = "Control+K";
export const ID = "id";
export const CONTROL_SHIFT_N = "Control+Shift+N";
export const ALT_A = "Alt+KeyA";
export const ALT_X = "Alt+KeyX";
export const ALT_E = "Alt+KeyE";
export const ALT_SHIFT_UP = "Alt+Shift+ArrowUp";
export const ALT_SHIFT_DOWN = "Alt+Shift+ArrowDown";
